import * as React from 'react';

export function Pending(): React.ReactElement {
  return (
    <svg
      className="overflow-visible"
      data-testid="pending"
      aria-hidden={true}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={72}
      height={72}
      viewBox="0 0 168 168"
    >
      <defs>
        <path
          id="hex-pending"
          vectorEffect="non-scaling-stroke"
          fillRule="evenodd"
          strokeWidth="2"
          strokeLinecap="round"
          d="M165.302 94.59l-31.92 55.324A20.152 20.152 0 01115.924 160h-63.84a20.16 20.16 0 01-17.459-10.086L2.705 94.59a20.174 20.174 0 010-20.18l31.92-55.324A20.152 20.152 0 0152.083 9h63.84a20.16 20.16 0 0117.459 10.086l31.92 55.324a20.22 20.22 0 010 20.18z"
        />
      </defs>
      <g transform={`translate(12 12)`}>
        <use
          className="fill-cyan-50 origin-center pending-spin"
          xlinkHref="#hex-pending"
        />
      </g>
      <g className="origin-center pending-spin">
        <use
          className="stroke-cyan-600 pending-indicator"
          fill="none"
          xlinkHref="#hex-pending"
        />
      </g>
    </svg>
  );
}

export function Error(): React.ReactElement {
  return (
    <svg aria-hidden={true} width="72" height="72" viewBox="0 0 72 72">
      <path
        className="fill-red-50"
        d="M44.066 13.023l24.508 48.26A6 6 0 0163.224 70H14.517a4 4 0 01-3.566-5.811l25.983-51.166a4 4 0 017.132 0z"
      />
      <g
        className="stroke-red-600"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="square"
        strokeWidth="2"
      >
        <path d="M39.066 8.023L65.05 59.19A4 4 0 0161.483 65H9.517a4 4 0 01-3.566-5.811L31.934 8.023a4 4 0 017.132 0z" />
        <path d="M36 52a3 3 0 013 3v1a3 3 0 01-3 3h-1a3 3 0 01-3-3v-1a3 3 0 013-3h1zm.956-27a2 2 0 012 2v.044h0l-.35 16a2 2 0 01-2 1.956h-2.212a2 2 0 01-2-1.956l-.35-16A2 2 0 0134 25h2.956z" />
      </g>
    </svg>
  );
}

export function Success(): React.ReactElement {
  return (
    <svg
      aria-hidden={true}
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="41" cy="41" r="28" fill="#E7F6EA" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36 9C21.0883 9 9 21.0883 9 36C9 50.9117 21.0883 63 36 63C50.9117 63 63 50.9117 63 36C63 21.0883 50.9117 9 36 9ZM7 36C7 19.9837 19.9837 7 36 7C52.0163 7 65 19.9837 65 36C65 52.0163 52.0163 65 36 65C19.9837 65 7 52.0163 7 36Z"
        fill="#49AF5B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.7146 29.3005C47.1009 29.6951 47.0942 30.3282 46.6995 30.7146L34.4415 42.7146C34.0527 43.0951 33.4311 43.0951 33.0424 42.7146L26.3005 36.1146C25.9058 35.7282 25.8991 35.0951 26.2854 34.7005C26.6718 34.3058 27.3049 34.2991 27.6995 34.6854L33.7419 40.6006L45.3005 29.2854C45.6951 28.8991 46.3282 28.9058 46.7146 29.3005Z"
        fill="#49AF5B"
      />
    </svg>
  );
}

export function Drive(): React.ReactElement {
  return (
    <svg aria-hidden={true} width="72" height="72" viewBox="0 0 72 72">
      <path
        className="fill-cyan-50"
        d="M18 8h43a4 4 0 014 4v54a6 6 0 01-6 6H20a4 4 0 01-4-4V10a2 2 0 012-2z"
      />
      <path
        className="fill-cyan-600"
        d="M45 19a1 1 0 010 2H18a1 1 0 010-2h27zm8-7a1 1 0 010 2H18a1 1 0 010-2h35z"
      />
      <g
        className="stroke-cyan-600"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <rect width="49" height="64" x="11" y="3" rx="4" />
        <path d="M41.79 56H29.14a2 2 0 01-1.73-.996l-2.832-4.878a2 2 0 01-.008-1.995l6.342-11.122A2 2 0 0132.65 36h5.63a2 2 0 011.738 1.01L46.36 48.13a2 2 0 01-.007 1.995l-2.832 4.878a2 2 0 01-1.73.996zM28.293 55.798l7.075-12.428M31.806 36.495l7.245 12.696M46.559 49.364H32.294" />
      </g>
    </svg>
  );
}

export function Email(): React.ReactElement {
  return (
    <svg aria-hidden={true} width="72" height="72" viewBox="0 0 72 72">
      <path
        className="fill-cyan-50"
        d="M61 9a4 4 0 014 4v9l5.603 4.803A4 4 0 0172 29.84V63a6 6 0 01-6 6H12a4 4 0 01-4-4V28.92a2 2 0 01.698-1.519L15 22V11a2 2 0 012-2h44z"
      />
      <path
        className="fill-cyan-600"
        d="M44 20a1 1 0 010 2H18a1 1 0 010-2h26zm8-7a1 1 0 010 2H18a1 1 0 010-2h34z"
      />
      <g
        className="stroke-cyan-600"
        fill="none"
        fillRule="evenodd"
        strokeWidth="2"
      >
        <path d="M10 33V8a4 4 0 014-4h42a4 4 0 014 4v25h0" />
        <path d="M60 17l5.603 4.803A4 4 0 0167 24.84V60a4 4 0 01-4 4H7a4 4 0 01-4-4V24.84a4 4 0 011.397-3.037L10 17h0M67 28L42 46" />
        <path d="M4 63l28.685-20.357a4 4 0 014.63 0L66 63h0M3 28l25 18" />
      </g>
    </svg>
  );
}

export function Download(): React.ReactElement {
  return (
    <svg aria-hidden={true} width="72" height="72" viewBox="0 0 72 72">
      <path
        className="fill-cyan-50"
        d="M18 7h43a4 4 0 014 4v54a6 6 0 01-6 6H20a4 4 0 01-4-4V9a2 2 0 012-2z"
      />
      <path
        className="fill-cyan-600"
        d="M45 18a1 1 0 010 2H18a1 1 0 010-2h27zm8-7a1 1 0 010 2H18a1 1 0 010-2h35z"
      />
      <g
        className="stroke-cyan-600"
        fill="none"
        fillRule="evenodd"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect width="49" height="64" x="11" y="2" rx="4" />
        <path d="M42 45l-7 7-7-7M35 51.25v-17.5" />
      </g>
    </svg>
  );
}
